'use client'

import { AccountControlCard } from '@repo/ui/AccountControlCard'
import { ComingUpTimeline } from '@repo/dashboard/ComingUpTimeline'
import { InvoicesCard } from '@repo/ui/InvoicesCard'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useState } from 'react'
import { WorkflowProgressCard } from '@repo/ui/WorkflowProgressCard'
import { WorkspaceDetailsCard } from '@repo/ui/WorkspaceDetailsCard'
import MUIBox from '@mui/material/Box'
import MUIButton from '@mui/material/Button'
import MUIPaper from '@mui/material/Paper'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import styles from './MatterWorkspaceModule.module.scss'

export const MatterWorkspaceModule = () => {
  const [controlVisible, setControlVisible] = useState<boolean>(true)
  const { currentMatter } = useMattersStore()
  const { clientNo, matterNo } = currentMatter || {}

  return (
    <MUIStack
      direction="column"
      sx={{ width: '100%', maxWidth: '1600px', margin: '0 auto', padding: '24px 40px 40px' }}
      gap={'24px'}
      data-testid="MatterWorkspaceModule"
    >
      {currentMatter ? (
        <MUIBox
          sx={{
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateColumns: 'repeat(3, minmax(17rem, 100%))',
            gridTemplateRows: 'repeat(3, minmax(17rem, 17rem))',
            gridGap: '24px'
          }}
        >
          <MUIStack sx={{ gridArea: '1/1/2/2' }}>
            <WorkflowProgressCard sx={{ height: 'auto', width: '100%' }} />
          </MUIStack>
          <MUIStack sx={{ gridArea: '1/2/2/3', position: 'relative' }}>
            <MUIStack
              justifyContent="flex-end"
              direction="row"
              gap={0}
              sx={{
                position: 'absolute',
                top: '0.85rem',
                right: '1rem',
                zIndex: 9
              }}
            >
              <MUIButton
                onClick={() => setControlVisible(true)}
                className={`${styles.buttonSelect} ${controlVisible ? styles.active : ''}`}
                sx={{ fontSize: '0.875rem', textTransform: 'capitalize', padding: '0' }}
              >
                Control
              </MUIButton>
              <MUIButton
                onClick={() => setControlVisible(false)}
                className={`${styles.buttonSelect} ${!controlVisible ? styles.active : ''}`}
                sx={{
                  fontSize: '0.875rem',
                  textTransform: 'capitalize',
                  padding: '0',
                  borderLeft: '1px solid #C5CBD7',
                  borderRadius: '0',
                  marginRight: '2px'
                }}
              >
                Invoices
              </MUIButton>
            </MUIStack>
            {controlVisible ? (
              <AccountControlCard matterWorkspace={true} sx={{ height: 'auto', width: '100%' }} />
            ) : (
              <InvoicesCard matterWorkspaceVisible={true} />
            )}
          </MUIStack>
          <MUIStack sx={{ gridArea: '1/3/4/4' }}>
            <WorkspaceDetailsCard sx={{ height: 'auto', width: '100%', minHeight: '-webkit-fill-available' }} />
          </MUIStack>
          <MUIStack sx={{ gridArea: '2/1/4/3' }}>
            <ComingUpTimeline
              matterWorkspaceVisible
              clientNo={clientNo || ''}
              matterNo={matterNo ? matterNo.toString() : '1'}
            />
          </MUIStack>
        </MUIBox>
      ) : (
        <MUIPaper
          sx={{
            alignItems: 'center',
            background: 'white',
            border: '1px solid #D8DCE5',
            borderRadius: 1,
            boxShadow: 'none',
            display: 'flex',
            height: 'auto',
            justifyContent: 'center',
            minHeight: '5rem',
            minWidth: '100%',
            padding: '0',
            position: 'relative',
            width: '100%'
          }}
        >
          <MUITypography variant="h6" sx={{ mb: 0 }}>
            Please select a matter to view details
          </MUITypography>
        </MUIPaper>
      )}
    </MUIStack>
  )
}
